// Demo-mode contact — shown when no active Connect call.
// In production, this is replaced by real contact attributes + Contact Lens data.

export const MOCK_CONTACT = {
  brandName: 'knktr.ai',
  knowledgeBaseId: 'LUYGE0CWAJ', // knktr-live KB — lets ?demo=1 exercise the copilot
  escalation: {
    brandName: 'knktr.ai',
    reason: 'Low retrieval confidence on a billing dispute + repeat-contact detected — routed to a human specialist.',
    trigger: 'low-confidence',
    handoverQuestion: "There's a charge I don't recognise — about $240 more than usual. Why?",
    lastQuestion: "There's a charge I don't recognise — about $240 more than usual. Why?",
    lastAnswer:
      "That charge relates to a data overage on your April billing cycle. Let me connect you with a billing specialist who has your full history.",
  },
  customer: {
    name: 'Sarah Mitchell',
    account: 'AU-28441',
    plan: 'Business Pro',
    phone: '+61 412 345 678',
  },
  meta: {
    contactId: 'CTX-20260520-0042',
    queue: 'Billing Support',
    startTime: '14:01:54',
    dnis: '+61 2 8348 7123',
    channel: 'VOICE',
  },
  aiHandled: true,
  aiHandledSeconds: 187,
  intents: ['billing_query', 'upgrade_interest'],
  aiSummary:
    'Customer calling about an unexpected charge on her April invoice — approximately $240 above her usual amount. She contacted support on the 12th of May regarding the same issue; it was not resolved. Wants an itemised breakdown and is open to a credit. Receptive to upgrade discussion if pricing is clearly justified.',
  transcript: [
    {
      speaker: 'AI',
      text: 'Thanks for calling. How can I help you today?',
      time: '14:02:01',
      entities: [],
    },
    {
      speaker: 'Cust',
      text: "Hi, I need to talk about my invoice. There's a charge I don't recognise — about $240 more than usual.",
      time: '14:02:08',
      entities: ['$240'],
      sentiment: 'NEUTRAL',
    },
    {
      speaker: 'AI',
      text: "I can see your April invoice. I'm looking into that charge now. Could you hold for just a moment?",
      time: '14:02:15',
      entities: [],
    },
    {
      speaker: 'Cust',
      text: "Sure, but this is the second time I've called about this. I called on the 12th of May.",
      time: '14:02:22',
      entities: ['12th of May'],
      sentiment: 'NEGATIVE',
    },
    {
      speaker: 'AI',
      text: "I can see that contact on your record — I'm sorry it wasn't resolved. I'm transferring you to a billing specialist now who has full context.",
      time: '14:05:01',
      entities: [],
    },
  ],
  sentiment: null, // Phase 3 (2026-09-14): the 0–100 score is retired; pills derive from per-line labels above
  suggestedResponses: [
    "I can see the charge is related to a data overage on your Business Pro plan during the April billing cycle — specifically 42GB above your 100GB monthly cap.",
    "I'd like to apply a one-time courtesy credit of $120 to your account and walk you through usage alerts so this doesn't happen again.",
    "Would you be open to discussing Business Pro Plus? It includes unlimited data and would have avoided this charge entirely — and it's only $18 more per month.",
  ],
  kbArticles: [
    { title: 'Business Pro — Data Overage Policy', id: 'KB-0041' },
    { title: 'Billing Credit Process & Approval Limits', id: 'KB-0089' },
    { title: 'Business Pro Plus — Feature Comparison', id: 'KB-0112' },
  ],
  piiDetected: 'Phone number redacted from transcript',
  contextAlerts: [
    {
      type: 'warning',
      text: 'Previous contact (12 May) unresolved — same billing issue. Customer flagged as churn risk.',
    },
  ],
};
